import React from 'react';
import { motion } from 'framer-motion';
import { Headphones } from 'lucide-react';
export function PodcastCTA() {
  return <section id="podcast" className="bg-[#151515] py-20 border-y border-dark-lighter" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-107">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-108">
            <div className="relative rounded-lg overflow-hidden shadow-2xl" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/hN5hW5qpEggMQTritVdtQw/mike-curry-podcast.png" alt="Mike Curry Podcast Studio" className="w-full h-auto" data-id="element-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" data-id="element-111"></div>
              <div className="absolute bottom-6 left-6 flex items-center space-x-2" data-id="element-112">
                <div className="flex space-x-1 items-end h-6" data-id="element-113">
                  {[1, 2, 3, 4, 5].map(i => <motion.div key={i} animate={{
                  height: [10, 24, 10]
                }} transition={{
                  repeat: Infinity,
                  duration: 1,
                  delay: i * 0.1
                }} className="w-1 bg-gold" data-id="element-114" />)}
                </div>
                <span className="text-white font-bold tracking-wider text-sm uppercase" data-id="element-115">
                  Now Streaming
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-116">
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-117">
              The Podcast
            </span>
            <h2 className="font-heading text-4xl md:text-6xl text-white mb-6 leading-none" data-id="element-118">
              Real Talk. Real Stories.
              <br data-id="element-119" />
              Real Transformation.
            </h2>
            <p className="text-gray-400 text-lg mb-8 max-w-xl" data-id="element-120">
              Join Mike and guests for raw, unfiltered conversations about
              addiction, recovery, faith, and what it really takes to build a
              life worth living.
            </p>
            <a href="#" className="inline-flex items-center bg-white text-black hover:bg-gold transition-colors font-bold py-3 px-8 rounded-sm uppercase tracking-wide" data-id="element-121">
              <Headphones className="mr-2 w-5 h-5" data-id="element-122" />
              Listen Now
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}